import React, { useState } from 'react'
import {
	Divider,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
	ModalFooter,
	Progress,
	Text,
	Checkbox,
	Box,
} from '@chakra-ui/react'
import Select from '../chakra-react-select'
import {
	GA_CATEGORY_DIALOG_BOX,
	sectionDetailedTrack,
} from '../../containers/repository/repo.utils'
import { useLanguageContext } from '../../context/locale.context'
import { SquareCheckboxIcon } from '../../assets/svgIcons/customReactIcons'
import styles from './exportFormsDialog.module.css'
import ButtonCTA from './../globalComponents/button/index'

const ExportFormsDialog = ({
	isOpen,
	onClose,
	exportForms,
	isLoading,
	formsList,
	setSelectedForms,
	selectedForms,
}) => {
	const {
		state: { locale },
	} = useLanguageContext()
	const options = formsList.map((f, i) => {
		f['form_sequence_id'] = i + 1
		return {
			label: f.form_name,
			value: f.form_id,
			data: f,
		}
	})
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			closeOnOverlayClick={false}
			isCentered
			variant='activityMenuModal'
		>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{locale['Export Forms Data to PDF']}</ModalHeader>
				<ModalCloseButton />
				<Divider />
				<ModalBody>
					<Text
						fontWeight='500'
						fontSize='0.875rem'
						color='gray.400'
						borderBottom='1px solid #D9D9D9'
						pb='0.625rem'
					>
						{locale['Select Forms']}
					</Text>
					{options.map(form => {
						return (
							<Box
								py='0.8rem'
								borderBottom='1px solid #D9D9D9'
								overflowY='auto'
								fontSize='0.875rem'
							>
								<Checkbox
									className={styles.exportFormsCheckbox}
									colorScheme='white'
									border='none'
									icon={
										<SquareCheckboxIcon
											iconProps={{ width: '24px', height: '24px' }}
										/>
									}
									value={form.value}
									onChange={e => {
										if (e.target.checked) {
											setSelectedForms(prevState => {
												return [...prevState, { ...form }]
											})
										} else {
											setSelectedForms(prevState => {
												let filtered = prevState.filter(
													item => form.value !== item.value
												)
												return [...filtered]
											})
										}
									}}
								>
									{form.label}
								</Checkbox>
							</Box>
						)
					})}

					{/* <Select
						isMulti={true}
						isDisabled={false}
						id={'export-forms'}
						options={options}
						onChange={setSelectedForms}
						placeholder={locale['Select Forms']}
						borderRadius='md'
						value={selectedForms}
						size='sm'
					/> */}
					{isLoading && <Progress my={5} size='xs' isIndeterminate />}
				</ModalBody>
				<ModalFooter>
					<ButtonCTA
						variant='modalCloseButton'
						mr='1rem'
						onClick={e => {
							sectionDetailedTrack({
								category: GA_CATEGORY_DIALOG_BOX,
								action: 'Export Forms Dialog',
								label: 'Close Selected',
							})
							onClose(e)
						}}
					>
						{locale['Close']}
					</ButtonCTA>
					<ButtonCTA
						variant='modalSubmitButton'
						isLoading={isLoading}
						onClick={e => {
							sectionDetailedTrack({
								category: GA_CATEGORY_DIALOG_BOX,
								action: 'Export Forms Dialog',
								label: 'Export Selected',
							})
							exportForms(e)
						}}
					>
						{locale['Export']}
					</ButtonCTA>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}
export default ExportFormsDialog
